module.exports = "<p>Explore, touch and experience the exhibition with your family. Free entry for children under 12 and Family tickets available.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/news/kidsandfamilies-excerpt.md
// module id = 218
// module chunks = 0